<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InjectMetaTags from 'src/mixins/injectMetaTags';
import CookieManagement from 'src/mixins/cookieManagement';
import ShowRefreshNotification from 'src/mixins/showRefreshNotification';

export default {
  name: 'App',
  computed: {
    ...mapGetters('config', ['config']),
  },
  mixins: [InjectMetaTags, ShowRefreshNotification, CookieManagement],
  methods: {
    setCookieAndReload(value) {
      this.$q.cookies.set('mijnomgeving-version', value, {
        path: '/',
        expires: 30,
        secure: true,
        sameSite: 'Strict',
      });
      /// 05-02-2021 remove old cookie from client browser (remove by expire date)
      this.$q.cookies.set('mijnomgeving-version', '', {
        path: '/inloggen',
        expires: -1,
        secure: true,
        sameSite: 'Strict',
      });
      if (this.$q.cookies.get('mijnomgeving-version') === value) window.location.reload(true);
    },
    ...mapActions('user', ['setLabel']),
  },
  beforeMount() {
    if (navigator.cookieEnabled) {
      const value = this.config.APP.RELEASE_TAG ? this.config.APP.RELEASE_TAG : 'local-v';
      if (
        window.location.href.startsWith('https://') &&
        (!this.$q.cookies.has('mijnomgeving-version') || this.$q.cookies.get('mijnomgeving-version') !== value)
      ) {
        this.setCookieAndReload(value);
      }
    }
  },
  created() {
    this.setLabel();
  },
};
</script>
